<!--
  * @Author: jh 1758579481@qq.com
  * @Date: 2021/2/2
-->
<template>
</template>

<script>
  import {getAccsessToken} from '../../api'
  export default {
    name: "oAuth",
    data() {
      return {}
    },
    created() {
      let code = ''
      window.location.search.split('&').forEach(value => {
        if (value.indexOf('code') >= 0) {
          code = value.split('=')[1]
        }
      })
      getAccsessToken({
        code: code
      }).then(res=>{
        let data = res.Data
        this.$storage.set('openid',data.openid)
        this.$storage.set('unionid',data.unionid)
        this.$storage.set('circleUrl',data.headimgurl)
        this.$storage.set('name',data.nickname)
        this.$router.replace('/index')
      })
    },
    methods: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/oAuth.vue